<div class="workshop-container">
  <div class="workshop-container__header">
    <div class="workshop-container__header-left">
      <span class="workshop-container__header-title">{{ getTitle() }}</span>
      <span class="workshop-container__header-subtitle">Choose a date and submit your schedule request</span>
    </div>
  </div>

  <div class="workshop-container-body">
    @if (canScheduleWorkshop) {
      <div class="schedule-type-row">
        <label class="schedule-type-option" [class.is-active]="isCheckedWorkshop">
          <input
            type="checkbox"
            class="schedule-type-option__input"
            [(ngModel)]="isCheckedWorkshop"
            (change)="onCheckedWorkshop($event)"
          />
          <span class="schedule-type-option__label">Workshop</span>
        </label>
        <label class="schedule-type-option" [class.is-active]="isCheckedSiteVisit">
          <input
            type="checkbox"
            class="schedule-type-option__input"
            [(ngModel)]="isCheckedSiteVisit"
            (change)="onCheckedSiteVisit($event)"
          />
          <span class="schedule-type-option__label">Site Visit</span>
        </label>
      </div>
    }

    <div class="calendar-block">
      <label class="calendar-block__label">Preferred date</label>
      <app-griha-calendar
        [selectedDateValue]="selectedDateValue"
        (onSelectedDate)="onSelectedWeek($event)"
      >
      </app-griha-calendar>
    </div>

    <div class="form-field">
      <label class="form-field__label">Client Side Representative Email</label>
      <input
        class="form-field__input"
        matInput
        type="email"
        [(ngModel)]="representativeEmail"
        placeholder="Enter email"
        (keydown)="onKeyPress($event)"
      />
      @if (representativeEmailValidations) {
        <mat-error>Email is required</mat-error>
      }
    </div>

    <div class="form-field">
      <label class="form-field__label">Client Side Representative Number</label>
      <input
        class="form-field__input"
        matInput
        type="text"
        [(ngModel)]="representativeNumber"
        placeholder="Enter mobile number"
        (keydown)="onKeyPress($event)"
      />
      @if (representativeNumberValidations) {
        <mat-error>Phone number is required</mat-error>
      }
    </div>

    @if (isWorkshopOrBothChecked) {
      <div class="form-field">
        <label class="form-field__label">Add Attendees (Email)</label>
        <input
          class="form-field__input"
          matInput
          type="text"
          [(ngModel)]="attendeesName"
          placeholder="Enter email and press Enter"
          (keydown)="onKeyPress($event)"
          (blur)="enterAttendee()"
        />
        <div class="form-field__attendees">
          <app-meeting-attendees
            [attendees]="attendeesNames"
            [isRemoval]="removal"
            (onDeletedAttendees)="onDeletedAttendees($event)"
          ></app-meeting-attendees>
        </div>
      </div>
    }
  </div>

  <div class="workshop-container__footer">
    <button type="button" class="btn-ghost" (click)="onCancelSchedule()">Cancel</button>
    <button
      type="button"
      class="btn-primary"
      [disabled]="isAttendeeInvalid"
      (click)="onClickSchedule()"
    >
      {{ action }}
    </button>
  </div>
</div>
